import React from "react";
import { Link } from "react-router-dom";

function MobileControls() {
  return (
    // <!-- mobile navigation controls -->
    <div className="mobile-controls">
      <span className="mobile-control-group mobile-header-icons">
        {/* <!-- Add more mobile controls here. These will be on the right side of the mobile page header section --> */}
      </span>
      <div className="mobile-control-group main-nav-icons">
        <div className="mobile-control">
          <Link to="/search" className="first-level-link">
            <span className="ca-gov-icon-search mobile-search-button" aria-hidden="true"></span>
          </Link>
        </div>
        <button
          id="nav-icon3"
          className="mobile-control toggle-menu"
          aria-expanded="false"
          aria-controls="navigation"
          data-toggle="collapse"
          data-target="#navigation"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span className="sr-only">Menu</span>
        </button>
      </div>
    </div>
  );
}

export default MobileControls;
